(() => {
  const source = document.getElementById('kb-builder-experience-copy');
  if (!source) return;
  const decoder = document.createElement('textarea');
  const labels = Object.fromEntries(Object.entries(JSON.parse(source.textContent)).map(([key, value]) => {
    decoder.innerHTML = value;
    return [key, decoder.value];
  }));
  const mobile = matchMedia('(max-width: 749px)');
  const originalHeadings = new WeakMap();
  const previewShells = new WeakMap();
  const mounted = new WeakSet();
  const guideHomes = new WeakMap();
  let queued = false;
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const observer = new MutationObserver(schedule);
  function watch() {
    observer.observe(document.body, {subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['data-kb-mobile-step', 'data-kb-config-state', 'data-kb-catalog-state', 'aria-pressed', 'hidden', 'data-kb-mobile-nav-portal', 'data-preview-expanded']});
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  function update() {
    queued = false;
    observer.disconnect();
    document.querySelectorAll('[data-kb-full-builder]').forEach(enhance);
    watch();
  }
  function enhance(root) {
    const heading = root.querySelector('.kb-full-builder__heading');
    const actions = root.querySelector('.kb-full-builder__actions');
    const list = root.querySelector('[data-kb-model-list]');
    if (!heading || !actions || !list) return;
    if (!previewShells.has(root)) previewShells.set(root, root.querySelector('.kb-full-builder__stage-shell'));
    const previewShell = previewShells.get(root);
    if (previewShell?.dataset.previewExpanded === 'true') {
      if (previewShell.parentElement !== document.body) document.body.append(previewShell);
      previewShell.removeAttribute('inert');
    }
    if (!mounted.has(root)) {
      mounted.add(root);
      root.dataset.kbExperience = 'true';
      root.addEventListener('change', schedule);
      const panSurface = event => event.target.closest('.kb-full-builder__product-photo-viewport, .kb-full-builder__ready-made-viewport, .kb-full-builder__stage');
      let drag = null;
      const pan = event => {
        const surface = drag?.surface;
        if (!surface || drag.id !== event.pointerId || !previewShell?.querySelector('[data-kb-preview-control="zoom"][aria-pressed="true"]')) return;
        const rect = surface.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const x = Math.max(0, Math.min(100, drag.originX - (event.clientX - drag.x) / rect.width * 100));
        const y = Math.max(0, Math.min(100, drag.originY - (event.clientY - drag.y) / rect.height * 100));
        root.style.setProperty('--kb-detail-x', x + '%');
        root.style.setProperty('--kb-detail-y', y + '%');
        previewShell.style.setProperty('--kb-detail-x', x + '%');
        previewShell.style.setProperty('--kb-detail-y', y + '%');
      };
      previewShell?.addEventListener('pointerdown', event => {
        const surface = panSurface(event);
        if (surface && previewShell.querySelector('[data-kb-preview-control="zoom"][aria-pressed="true"]')) {
          drag = {surface, id: event.pointerId, x: event.clientX, y: event.clientY,
            originX: parseFloat(root.style.getPropertyValue('--kb-detail-x') || '0'),
            originY: parseFloat(root.style.getPropertyValue('--kb-detail-y') || '50')};
          surface.setPointerCapture(event.pointerId);
          pan(event);
        }
      });
      previewShell?.addEventListener('pointermove', event => { if (event.buttons) pan(event); });
      previewShell?.addEventListener('pointerup', () => { drag = null; });
      previewShell?.addEventListener('pointercancel', () => { drag = null; });
      originalHeadings.set(root, heading.textContent.trim());
      const more = make('details', 'kb-exp-more');
      const summary = make('summary', 'kb-exp-more-toggle', labels.more);
      const panel = make('div', 'kb-exp-more-panel');
      more.append(summary, panel);
      actions.querySelectorAll('[data-kb-full-action="share"],[data-kb-full-action="reset"]').forEach(button => {
        panel.append(button);
        button.addEventListener('click', () => { if (mobile.matches) more.open = false; });
      });
      actions.append(more);
      more.addEventListener('keydown', event => {
        if (mobile.matches && event.key === 'Escape') { more.open = false; summary.focus(); }
      });
      document.addEventListener('click', event => {
        if (mobile.matches && !more.contains(event.target)) more.open = false;
      });
      const caption = make('span', 'kb-exp-step');
      root.querySelector('[data-kb-mobile-progress]')?.prepend(caption);
    }
    if (root.dataset.kbExperienceMobile !== String(mobile.matches)) {
      root.dataset.kbExperienceMobile = String(mobile.matches);
      root.querySelector('.kb-exp-more').open = !mobile.matches;
    }
    const cards = [...list.querySelectorAll('[data-kb-model-card]')];
    const signature = cards.map(card => card.dataset.modelHandle).sort().join('|');
    if (cards.length && (list.dataset.kbExperienceOrder !== signature || !list.querySelector('.kb-exp-group'))) {
      list.dataset.kbExperienceOrder = signature;
      list.querySelectorAll('.kb-exp-group').forEach(node => node.remove());
      const priority = ['original','classic','air','kaze','katana'];
      const groups = [
        [labels.core, cards.filter(c => c.dataset.modelHandle !== 'tanto' && !c.dataset.modelHandle.includes('edition'))],
        [labels.kids, cards.filter(c => c.dataset.modelHandle === 'tanto')],
        [labels.pre, cards.filter(c => c.dataset.modelHandle.includes('edition'))]
      ];
      groups[0][1].sort((a,b) => {
        const x = priority.indexOf(a.dataset.modelHandle), y = priority.indexOf(b.dataset.modelHandle);
        return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
      });
      groups.forEach(([name, items]) => {
        if (!items.length) return;
        const label = make('div', 'kb-exp-group', name);
        label.setAttribute('role', 'presentation');
        list.append(label, ...items);
      });
    }
    const steps = [...root.querySelectorAll('[data-kb-mobile-step-key]')]
      .filter(step => !step.hidden && !['size','bar-color'].includes(step.dataset.kbMobileStepKey));
    const index = Math.max(0, Number(root.dataset.kbMobileStep || 1) - 1);
    const key = steps[index]?.dataset.kbMobileStepKey || 'model';
    const titleKey = {'model':'model','belt-color':'belt','embroidery':'embroidery','review':'review'}[key] || 'model';
    root.dataset.kbExperienceStep = key;
    previewShell?.querySelectorAll('[data-kb-preview-control]').forEach(button => {
      let caption = button.querySelector('.kb-exp-control-label');
      if (!caption) {
        caption = make('span', 'kb-exp-control-label');
        button.append(caption);
      }
      setText(caption, labels[button.dataset.kbPreviewControl === 'fullscreen' ? 'expand' : button.dataset.kbPreviewControl] || '');
      if (button.dataset.kbPreviewControl === 'fullscreen' && button.getAttribute('aria-expanded') === 'true') {
        setText(caption, labels.close);
        button.setAttribute('aria-label', labels.close);
      }
      if (button.dataset.kbPreviewControl === 'zoom') {
        const zoomed = button.getAttribute('aria-pressed') === 'true';
        setText(caption, zoomed ? labels.zoom_out : labels.zoom);
        button.setAttribute('aria-label', zoomed ? labels.zoom_out : labels.zoom);
        button.title = zoomed ? labels.zoom_out : labels.zoom;
        button.dataset.kbTooltip = button.title;
      }
    });
    setText(root.querySelector('[data-kb-side-tab="bar"] > span'), labels.rank_side);
    const breakdown = [...root.querySelectorAll('[data-kb-cost-breakdown] dt')];
    root.querySelectorAll('[data-kb-side-tab]').forEach(tab => {
      let cost = tab.querySelector('.kb-exp-side-cost');
      if (!cost) { cost = make('small', 'kb-exp-side-cost'); tab.append(cost); }
      const side = tab.dataset.kbSideTab === 'bar' ? 'Bar' : 'Logo';
      const row = breakdown.find(term => [root.dataset['labelPrice' + side + 'Text'], root.dataset['labelPrice' + side + 'Logo']].includes(term.textContent));
      setText(cost, row?.nextElementSibling?.textContent || '');
      cost.hidden = !row;
    });
    const modes = root.querySelector('[data-kb-side-panel] > fieldset');
    const textFields = root.querySelector('[data-kb-text-fields]');
    if (textFields && !textFields.querySelector('.kb-exp-typography')) {
      const language = textFields.querySelector(':scope > .kb-full-builder__field');
      const font = textFields.querySelector(':scope > label');
      const orientation = textFields.querySelector(':scope > fieldset:not(.kb-full-builder__thread-colors)');
      if (language && font && orientation) {
        const group = make('div', 'kb-exp-typography');
        language.before(group);
        group.append(language, font, orientation);
      }
    }
    if (modes) {
      let cost = modes.querySelector('.kb-exp-inline-cost');
      if (!cost) { cost = make('p', 'kb-exp-inline-cost'); modes.append(cost); }
      setText(cost, root.querySelector('[data-kb-cost-breakdown-total]')?.textContent || '');
      cost.hidden = !cost.textContent;
    }
    const sizeSection = root.querySelector('.kb-full-builder__section--size');
    const guide = root.querySelector('[data-kb-size-guide-open]');
    const sizeHeading = sizeSection?.querySelector('.kb-full-builder__choice-heading');
    if (guide && sizeHeading) {
      if (!guideHomes.has(guide)) {
        const home = document.createComment('size-guide-position');
        guide.before(home);
        guideHomes.set(guide, home);
      }
      if (mobile.matches && guide.parentElement !== sizeHeading) sizeHeading.append(guide);
      if (!mobile.matches && guide.parentElement === sizeHeading) guideHomes.get(guide).after(guide);
    }
    const professorField = root.querySelector('[data-kb-professor-degree-field]');
    const professorSelect = root.querySelector('[data-kb-professor-degree]');
    if (professorField && professorSelect) {
      professorField.dataset.kbExperienceStripes = String(professorSelect.value !== '');
    }
    setText(heading, mobile.matches ? labels[titleKey] : originalHeadings.get(root));
    setText(root.querySelector('.kb-exp-step'), labels.step.replace('__CURRENT__', String(index + 1)).replace('__TOTAL__', String(steps.length || 4)));
    const nav = root.querySelector('.kb-full-builder__mobile-steps') || document.querySelector('.kb-full-builder__mobile-steps[data-kb-mobile-nav-portal="true"]');
    if (!nav) return;
    const review = root.querySelector('.kb-full-builder__section--review');
    if (review) {
      const addEdit = (parent, targetKey, label) => {
        if (!parent || parent.querySelector('.kb-exp-edit')) return;
        const button = make('button', 'kb-exp-edit', label);
        button.type = 'button';
        button.dataset.kbEditStep = targetKey;
        button.addEventListener('click', () => {
          const target = steps.findIndex(step => step.dataset.kbMobileStepKey === targetKey);
          if (target < 0) return;
          if (mobile.matches) {
            const count = Math.max(0, Number(root.dataset.kbMobileStep) - 1 - target);
            for (let i = 0; i < count; i++) nav.querySelector('[data-kb-full-back]')?.click();
          }
          const section = steps[target];
          section.scrollIntoView({block: 'start'});
          const focusTarget = section.querySelector('button:not([disabled]):not([hidden]), input:not([type="hidden"])');
          focusTarget?.focus({preventScroll: true});
        });
        parent.append(button);
      };
      addEdit(review.querySelector('[data-kb-summary-model]'), 'belt-color', labels.edit_belt);
      addEdit(review.querySelector('.kb-full-builder__purchase-customization h5'), 'embroidery', labels.edit_embroidery);
    }
    nav.dataset.kbExperienceNav = key;
    let info = nav.querySelector('.kb-exp-selection');
    if (!info) {
      info = make('div', 'kb-exp-selection');
      info.append(make('strong','kb-exp-selection-name'),make('span','kb-exp-selection-price'));
      info.setAttribute('aria-label', labels.selected);
      nav.prepend(info);
    }
    const selected = cards.find(card => card.getAttribute('aria-pressed') === 'true' || card.classList.contains('is-selected'));
    const selectionSummary = key === 'belt-color' ? root.querySelector('[data-kb-belt-size-summary]')?.textContent.trim() : '';
    setText(info.querySelector('strong'), selectionSummary || selected?.querySelector('.kb-full-builder__model-name')?.textContent.trim() || '');
    const price = root.querySelector('[data-kb-summary-price]')?.textContent.trim() || '';
    const ready = root.dataset.kbConfigState === 'ready' && root.dataset.kbLoading !== 'true';
    setText(info.querySelector('span'), ready && price ? labels.total + ' ' + price : '');
    info.hidden = !selected || !mobile.matches || key === 'review';
    const next = nav.querySelector('[data-kb-full-next]');
    const nextKey = steps[index + 1]?.dataset.kbMobileStepKey;
    const nextLabel = labels[{'belt-color':'next_belt','embroidery':'next_embroidery','review':'next_review'}[nextKey]] || labels.next;
    if (mobile.matches && next) {
      setText(next, nextLabel);
      next.setAttribute('aria-label', nextLabel);
    }
  }
  mobile.addEventListener('change', schedule);
  watch();
  schedule();
})();
